import { create } from 'zustand';

/** Homebase customizing state, shared by the board and the rail controls. */
export const useHomeEdit = create<{
  editing: boolean;
  gallery: boolean;
  setEditing: (v: boolean) => void;
  setGallery: (v: boolean) => void;
}>((set) => ({
  editing: false,
  gallery: false,
  setEditing: (editing) => set({ editing }),
  setGallery: (gallery) => set({ gallery }),
}));
